// @core/api/endpoints/bootstrap/test_auto_unseal.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  TestAutoUnsealRequest,
  TestAutoUnsealResponse,
} from '../../../types/bootstrap';

const BASE_PATH = '/bootstrap';

/**
 * Test auto-unseal connectivity
 * Tests connectivity to the selected KMS provider. Verifies that the provided credentials and key ID are valid without actually performing any operations.
 * @public This endpoint does not require authentication
 */
export async function TestAutoUnseal(
  data: TestAutoUnsealRequest,
  options?: RequestOptions
): Promise<TestAutoUnsealResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/setup/vault/test-auto-unseal`;
  const requestOptions = { ...options, skipAuth: true };
  return client.post<TestAutoUnsealResponse>(requestPath, data, requestOptions);
}
